import React from 'react'
import { H2 } from '../../../../../Heading/index'

const CLS = 'community-profile-settings'

export interface SettingsCardProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  headerActions?: React.ReactNode
  bordered?: boolean
  children?: React.ReactNode
}

function SettingsCard ({
  title,
  subtitle,
  headerActions,
  bordered = false,
  children,
}: SettingsCardProps) {
  return (
    <div className={`${CLS}__card${bordered ? ` ${CLS}__card--bordered` : ''}`}>
      <div className={`${CLS}__card-header`}>
        <div>
          <H2 className={`${CLS}__card-title`}>
            {title}
          </H2>
          {subtitle && (
            <p className={`${CLS}__card-subtitle`}>
              {subtitle}
            </p>
          )}
        </div>
        {headerActions}
      </div>
      {children}
    </div>
  )
}

export default SettingsCard
